import {
  Button,
  ButtonProps,
  Divider,
  DividerProps,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemProps,
  ListItemText,
  ListItemTextProps,
  Popover,
  PopoverProps,
  Stack,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { removeTheseProps } from '@/utils';

export type AppHeaderButtonProps = ButtonProps & {
  isActive?: boolean;
};

export const AppHeaderContainer = styled(Box)(({ theme: { palette } }) => ({
  height: 56,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 20px',
  backgroundColor: palette.blue800.main,
  overflow: 'hidden',
  color: palette.white.main,
  borderBottom: `1px solid black`,
}));

export const AppHeaderNavigationContainer = styled(Box)(
  ({ theme: { palette } }) => ({
    height: 50,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    overflow: 'hidden',
    color: palette.white.main,
    borderTop: `1px solid ${palette.blue500.main}`,
  }),
);

export const AppHeaderButton = styled(Button, {
  shouldForwardProp: removeTheseProps<AppHeaderButtonProps>('isActive'),
})<AppHeaderButtonProps>(({ isActive, theme }) => ({
  padding: 5,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 6,
  fontSize: 14,
  fontWeight: 700,
  textTransform: 'none',
  cursor: isActive ? 'pointer' : 'unset',
  color: !isActive ? '#8f9298' : theme.palette.white.main,
  borderTop: 'unset',
  borderBottom: `1px solid ${theme.palette.gray500.main}`,
  borderLeft: `1px solid ${theme.palette.gray500.main}`,
  borderRight: `1px solid ${theme.palette.gray500.main}`,
  ':hover': {
    backgroundColor: isActive
      ? theme.palette.black.main
      : theme.palette.gray800.main + 95,
  },
  transition: '200ms',
  borderRadius: 0,
  backgroundColor: isActive
    ? theme.palette.black.main
    : theme.palette.gray800.main,
}));
